import { useEffect, useState } from 'react';
import { listAnnouncements } from 'services';

export const useAnnouncements = (pageLimit = 20) => {
  const [data, setData] = useState({ announcements: [], next_token: null });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    listAnnouncements(pageLimit)
      .then((res) => setData(res?.data || { announcements: [], next_token: null }))
      .catch(() => setData({ announcements: [], next_token: null }))
      .finally(() => setLoading(false));
  }, [pageLimit]);

  return { data, loading };
};
